import { render } from "./QueButton.vue?vue&type=template&id=012ff604&scoped=true"
import script from "./QueButton.vue?vue&type=script&lang=js"
export * from "./QueButton.vue?vue&type=script&lang=js"

import "./QueButton.vue?vue&type=style&index=0&id=012ff604&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012ff604"]])

export default __exports__